import { AxiosError } from "axios";
export class ApiClientError extends AxiosError {
    constructor(message, code, config, request, response) {
        super(message, code, config, request, response);
        Object.setPrototypeOf(this, ApiClientError.prototype);
        this.name = "ApiClientError";
    }
    static fromResponse(message, response) {
        return new ApiClientError(message, undefined, response.config, response.request, response);
    }
}
export default ApiClientError;
